/* vh life — loading splash controller. Shows once per session, removes itself
   after the lift animation, respects reduced motion. Never blocks the page. */
(function () {
  "use strict";
  var el = document.querySelector("[data-vh-loader]");
  if (!el) return;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var once = el.getAttribute("data-once") !== "false";
  var seen = false;
  try { seen = once && sessionStorage.getItem("vh-loader-seen") === "1"; } catch (e) {}

  if (reduce || seen) { el.parentNode && el.parentNode.removeChild(el); return; }

  try { sessionStorage.setItem("vh-loader-seen", "1"); } catch (e) {}

  // remove after the CSS lift completes (animation ~1.9s) so it never lingers
  var done = function () { el.classList.add("is-done"); if (el.parentNode) el.parentNode.removeChild(el); };
  el.addEventListener("animationend", function (e) { if (e.animationName === "vhLoaderLift") done(); });
  setTimeout(done, 2400); // hard fallback
})();
